/**
 * 将组织级四段文本覆盖合并进 UI / 首页设置。
 * 规则：覆盖字段非空才替换；样式字段不动；无覆盖则原样返回。
 */
export function applyOrgBrandingToHomepageSettings(homepageSettings, branding) {
  if (!homepageSettings || !branding) return homepageSettings;
  const pc = { ...(homepageSettings.pc || {}) };
  const mobile = { ...(homepageSettings.mobile || {}) };
  if (branding.brand_text_pc) pc.brandText = branding.brand_text_pc;
  if (branding.brand_text_mobile) mobile.brandText = branding.brand_text_mobile;
  return { ...homepageSettings, pc, mobile };
}

export function applyOrgBrandingToUiSettings(settings, branding) {
  if (!settings || !branding) return settings;
  const next = { ...settings };
  if (next.titleBar && branding.title_text_pc) {
    next.titleBar = { ...next.titleBar, text: branding.title_text_pc };
  }
  if (next.mobileTitleBar && branding.title_text_mobile) {
    next.mobileTitleBar = { ...next.mobileTitleBar, text: branding.title_text_mobile };
  }
  if (next.homepageSettings) {
    next.homepageSettings = applyOrgBrandingToHomepageSettings(next.homepageSettings, branding);
  }
  return next;
}

/** 登录态拉取本帐号所属组织的有效覆盖（无权限点要求）；失败返回 null */
export async function fetchEffectiveOrgBranding(apiBaseUrl = '/api') {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const base = String(apiBaseUrl || '/api').replace(/\/$/, '');
    const res = await fetch(`${base}/admin/org-ui-branding/effective`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
    if (!res.ok) return null;
    const data = await res.json();
    if (!data?.success || !data.branding || !data.org_name) return null;
    return data.branding;
  } catch (e) {
    console.warn('拉取队伍品牌覆盖失败:', e);
    return null;
  }
}
